/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';

export function AsideProfessor() {
  return (
    <aside>
      <h3>교수님 전용</h3>
      <Link to="/professor/lecture-material">강의자료실</Link>
      <Link to="/professor/request-sample">견본도서요청</Link>
    </aside>
  );
}
